import AsosView from "../AsosView.vue";

export const asosRoute = [
  {
    path: "/asos",
    name: "asos",
    component: AsosView,
    meta: {
      key: "view_aso",
    },
  },
];
